import { Tree, TreeProps } from 'antd'
import { Key, useState } from 'react'

import styles from './pure-tree.module.scss'

type PureTreeProps = {
  onCheck?: (checkedIds: number[]) => void
  onExpand?: (expandedKey: Key[]) => void
  onSelect?: (selectedKey: Key[]) => void
  treeData: any[]
  initialState?: string[]
}

export const PureTree = ({ onCheck, onExpand, onSelect, treeData, initialState = [] }: PureTreeProps) => {
  const [expandedKeys, setExpandedKeys] = useState<Key[]>(['0-0-0', '0-0-1'])
  const [checkedKeys, setCheckedKeys] = useState<Key[]>(initialState)
  const [selectedKeys, setSelectedKeys] = useState<Key[]>([])
  const [autoExpandParent, setAutoExpandParent] = useState<boolean>(true)

  const handleExpand: TreeProps['onExpand'] = (expandedKeysValue) => {
    setExpandedKeys(expandedKeysValue)
    setAutoExpandParent(false)
    onExpand?.(expandedKeysValue)
  }

  const handleCheck: TreeProps['onCheck'] = (checkedKeysValue: Key[] | { checked: Key[]; halfChecked: Key[] }) => {
    setCheckedKeys(checkedKeysValue as Key[])
    // Important! We have keys like 1-1-1, take only last and not first-level items, for example, from 1-2 we will take 2 which is ID of element
    onCheck?.(
      (checkedKeysValue as []).filter((value: unknown) => typeof value === 'string').map((value: string) => Number(value.split('-').at(-1))),
    )
  }

  const handleSelect: TreeProps['onSelect'] = (selectedKeysValue, info) => {
    setSelectedKeys(selectedKeysValue)
    onSelect?.(selectedKeysValue)
  }

  return (
    <Tree
      autoExpandParent={autoExpandParent}
      checkedKeys={checkedKeys}
      className={styles.pureTree}
      expandedKeys={expandedKeys}
      onCheck={handleCheck}
      onExpand={handleExpand}
      onSelect={handleSelect}
      selectable={!!onSelect}
      selectedKeys={selectedKeys}
      treeData={treeData}
      checkable
    />
  )
}
